import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import Moment from 'moment';

import { endpointState } from '../../recoil/atoms';
import BitButton from '../../components/BitButton/BitButton';
import BitHeaderFull from '../../components/BitHeader/BitHeaderFull';
import BitPage from '../../components/BitPage/BitPage';
import BitInput from '../../components/BitInput/BitInput';
import BitLinkButton from '../../components/BitLinkButton/BitLinkButton';

const NewAreaComum: React.FC = () => {
	Moment.locale('pt-br');
	type typeResponseAxios = {
		[key: string]: any;
	};

	interface interfaceEmpreendimentos {
		value: {
			value: string | number;
			label: string;
			selected: boolean;
		}[];
		required: boolean;
	}

	const { urlEndpoint } = useRecoilValue(endpointState);
	const urlEndpointCreateAreaComum = `${urlEndpoint}/calendars/store`;
	const urlEndpointGetEmpreendimentos = `${urlEndpoint}/developments`;

	const token = localStorage.getItem('token');
	const typeUser = localStorage.getItem('type');

	const [nome, setNome] = useState({
		value: '',
		required: true,
	});
	const [tempoDuracao, setTempoDuracao] = useState({
		value: '',
		required: true,
	});
	const [descricao, setDescricao] = useState({
		value: '',
		required: false,
	});
	const [horarioInicio, setHorarioInicio] = useState({
		value: '',
		required: true,
	});
	const [horarioFim, setHorarioFim] = useState({
		value: '',
		required: true,
	});
	const [dataInicio, setDataInicio] = useState({
		value: '',
		required: false,
	});
	const [dataFim, setDataFim] = useState({
		value: '',
		required: false,
	});
	const [intervalo, setInterval] = useState({
		value: '0',
		required: false,
	});

	// NOVO: estado para observações
	const [observacoes, setObservacoes] = useState({
		value: '',
		required: false,
	});

	// NOVO: estados para bloqueios de período
	const [blocks, setBlocks] = useState<
		{ start_date: string; end_date: string; reason: string }[]
	>([]);
	const [newBlockStartDate, setNewBlockStartDate] = useState('');
	const [newBlockEndDate, setNewBlockEndDate] = useState('');
	const [newBlockReason, setNewBlockReason] = useState('');

	// NOVO: estados para bloqueios de horários específicos
	const [intervals, setIntervals] = useState<
		{ date: string; start_time: string; end_time: string; reason: string }[]
	>([]);
	const [newIntervalDate, setNewIntervalDate] = useState('');
	const [newIntervalStartTime, setNewIntervalStartTime] = useState('');
	const [newIntervalEndTime, setNewIntervalEndTime] = useState('');
	const [newIntervalReason, setNewIntervalReason] = useState('');

	// NOVO: estados para intervalos simples (seção 1)
	const [simpleIntervals, setSimpleIntervals] = useState<
		{ start_time: string; end_time: string }[]
	>([]);
	const [
		newSimpleIntervalStartTime,
		setNewSimpleIntervalStartTime,
	] = useState('');
	const [newSimpleIntervalEndTime, setNewSimpleIntervalEndTime] = useState(
		'',
	);

	const [
		politicaDeAgendamento,
		setPoliticaDeAgendamento,
	] = useState<interfaceEmpreendimentos>({
		value: [
			{
				value: '0',
				label: 'Agendamento Livre',
				selected: true,
			},
			{
				value: '1',
				label:
					'Agendamento único com intervalo (Pode agendar uma vez, mas só pode agendar novamente depois do intervalo informado abaixo)',
				selected: false,
			},
			{
				value: '2',
				label:
					'Agendamento único permanente (Só pode agendar uma vez, sem possibilidade de reagendar)',
				selected: false,
			},
		],
		required: true,
	});

	const isBlockedInterval = React.useMemo(() => {
		return !politicaDeAgendamento.value[1].selected;
	}, [politicaDeAgendamento]);

	const [
		empreendimentos,
		setEmpreendimentos,
	] = useState<interfaceEmpreendimentos>({
		value: [],
		required: true,
	});

	const [showRequiredBallon, setShowRequiredBallon] = useState(false);

	const currentFields = document.querySelectorAll(
		'input, select, textarea, button',
	);

	const limpaCampos = () => {
		setNome({
			value: '',
			required: nome.required,
		});
		setTempoDuracao({
			value: '',
			required: true,
		});
		setDescricao({
			value: '',
			required: false,
		});
		setHorarioInicio({
			value: '',
			required: true,
		});
		setHorarioFim({
			value: '',
			required: true,
		});
		setDataInicio({
			value: '',
			required: true,
		});
		setDataFim({
			value: '',
			required: true,
		});
		setInterval({
			value: '',
			required: true,
		});

		// NOVO: limpar observações
		setObservacoes({
			value: '',
			required: false,
		});

		// NOVO: limpar bloqueios e o item em edição
		setBlocks([]);
		setNewBlockStartDate('');
		setNewBlockEndDate('');
		setNewBlockReason('');

		// NOVO: limpar intervalos
		setIntervals([]);
		setNewIntervalDate('');
		setNewIntervalStartTime('');
		setNewIntervalEndTime('');
		setNewIntervalReason('');

		// NOVO: limpar intervalos simples
		setSimpleIntervals([]);
		setNewSimpleIntervalStartTime('');
		setNewSimpleIntervalEndTime('');

		setShowRequiredBallon(false);
	};

	const lockFields = (fields: NodeListOf<Element>) => {
		fields.forEach(function (elField) {
			elField.setAttribute('disabled', '');
		});
	};

	const unlockFields = (fields: NodeListOf<Element>) => {
		fields.forEach(function (elField) {
			elField.removeAttribute('disabled');
		});
	};

	useEffect(() => {
		axios
			.get(urlEndpointGetEmpreendimentos, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(function (response: typeResponseAxios) {
				const allEmpreendimentos = response.data.data.data;

				const newValueEmpreendimentos: {
					value: string | number;
					label: string;
					selected: boolean;
				}[] = [];

				if (typeUser === 'Porteiro') {
					newValueEmpreendimentos.push({
						value: allEmpreendimentos.id,
						label: allEmpreendimentos.name,
						selected: true,
					});
				} else {
					allEmpreendimentos.map((empreendimento: any) => {
						const isSelected = false;

						newValueEmpreendimentos.push({
							value: empreendimento.id,
							label: empreendimento.name,
							selected: isSelected,
						});
						return null;
					});
				}

				setEmpreendimentos({
					value: newValueEmpreendimentos,
					required: empreendimentos.required,
				});
			});
	}, []);

	const handleCadastrar = async (e: any) => {
		e?.preventDefault?.();

		setShowRequiredBallon(true);
		lockFields(currentFields);

		const entriesDevelopments = empreendimentos.value;
		const valueDevelopments: {
			[key: string]: string | number;
		}[] = [];

		entriesDevelopments.map(empreendimento => {
			if (empreendimento.selected) {
				valueDevelopments.push({
					id: empreendimento.value,
				});
			}
			return null;
		});

		const politica = politicaDeAgendamento.value.filter(
			item => item.selected,
		)[0];
		const politicaNumber = Number(politica.value);

		try {
			const response = await axios.post(
				urlEndpointCreateAreaComum,
				{
					name: nome.value,
					short_description: descricao.value || 'Sem descrição',
					observation: observacoes.value || '',
					development_id:
						valueDevelopments[0] !== undefined
							? valueDevelopments[0].id
							: null,
					event_range: tempoDuracao.value,
					start_time: horarioInicio.value,
					end_time: horarioFim.value,
					open_after: dataInicio.value
						? Moment(dataInicio.value).format('YYYY-MM-DD')
						: null,
					close_before: dataFim.value
						? Moment(dataFim.value).format('YYYY-MM-DD')
						: null,
					unique: politicaNumber >= 1 ? 1 : 0,
					interval:
						politicaNumber === 2 ? 0 : Number(intervalo.value),
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
						'Content-Type': 'application/json',
					},
				},
			);

			if (response.status === 201) {
				// NOVO: enviar bloqueios após criar a Área Comum
				const areaId =
					response.data?.data?.id ??
					response.data?.id ??
					response.data?.data?.calendar?.id;

				if (areaId && blocks.length > 0) {
					await Promise.all(
						blocks.map(b =>
							axios.post(
								`${urlEndpoint}/calendars/${areaId}/blocks`,
								{
									start_date: Moment(b.start_date).format(
										'YYYY-MM-DD',
									),
									end_date: b.end_date
										? Moment(b.end_date).format(
												'YYYY-MM-DD',
										  )
										: '',
									reason: b.reason,
								},
								{
									headers: {
										Authorization: `Bearer ${token}`,
										'Content-Type': 'application/json',
									},
								},
							),
						),
					);
				}

				// NOVO: enviar intervalos após criar a Área Comum
				if (areaId && intervals.length > 0) {
					await Promise.all(
						intervals.map(i =>
							axios.post(
								`${urlEndpoint}/calendars/${areaId}/intervals`,
								{
									date: Moment(i.date).format('YYYY-MM-DD'),
									start_time: i.start_time,
									end_time: i.end_time,
									reason: i.reason,
								},
								{
									headers: {
										Authorization: `Bearer ${token}`,
										'Content-Type': 'application/json',
									},
								},
							),
						),
					);
				}

				// NOVO: enviar intervalos simples após criar a Área Comum
				if (areaId && simpleIntervals.length > 0) {
					await Promise.all(
						simpleIntervals.map(i =>
							axios.post(
								`${urlEndpoint}/calendars/${areaId}/intervals`,
								{
									date: null,
									start_time: i.start_time,
									end_time: i.end_time,
									reason: null,
								},
								{
									headers: {
										Authorization: `Bearer ${token}`,
										'Content-Type': 'application/json',
									},
								},
							),
						),
					);
				}

				toast.success('Cadastro realizado com sucesso!', {
					position: 'bottom-right',
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: false,
					pauseOnHover: true,
					draggable: false,
					progress: undefined,
				});

				limpaCampos();
				unlockFields(currentFields);
				window.history.back();
			}
		} catch (error: any) {
			toast.error(
				'Erro ao cadastrar. Verifique os campos obrigatórios e tente novamente.',
				{
					position: 'bottom-right',
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: false,
					pauseOnHover: true,
					draggable: false,
					progress: undefined,
				},
			);
			unlockFields(currentFields);
		}
	};

	// NOVO: adicionar e remover bloqueios
	const handleAddBlock = () => {
		if (!newBlockStartDate) {
			toast.warn('Preencha Data Início do bloqueio.');
			return;
		}
		const start = Moment(newBlockStartDate, 'YYYY-MM-DD', true);
		if (!start.isValid()) {
			toast.warn('Data de início inválida.');
			return;
		}
		if (newBlockEndDate) {
			const end = Moment(newBlockEndDate, 'YYYY-MM-DD', true);
			if (!end.isValid()) {
				toast.warn('Data de fim inválida.');
				return;
			}
			if (end.isBefore(start)) {
				toast.warn(
					'Data de Fim não pode ser anterior à Data de Início.',
				);
				return;
			}
		}
		setBlocks(prev => [
			...prev,
			{
				start_date: newBlockStartDate,
				end_date: newBlockEndDate || '',
				reason: newBlockReason || '',
			},
		]);
		setNewBlockStartDate('');
		setNewBlockEndDate('');
		setNewBlockReason('');
	};

	const handleRemoveBlock = (index: number) => {
		setBlocks(prev => prev.filter((_, i) => i !== index));
	};

	// NOVO: adicionar e remover intervalos
	const handleAddInterval = () => {
		if (!newIntervalDate) {
			toast.warn('Preencha a data do bloqueio de horário.');
			return;
		}
		if (!newIntervalStartTime) {
			toast.warn('Preencha o horário de início.');
			return;
		}
		if (!newIntervalEndTime) {
			toast.warn('Preencha o horário de fim.');
			return;
		}

		const date = Moment(newIntervalDate, 'YYYY-MM-DD', true);
		if (!date.isValid()) {
			toast.warn('Data inválida.');
			return;
		}

		// Validar formato de horário (HH:MM)
		const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
		if (!timeRegex.test(newIntervalStartTime)) {
			toast.warn('Horário de início inválido. Use o formato HH:MM.');
			return;
		}
		if (!timeRegex.test(newIntervalEndTime)) {
			toast.warn('Horário de fim inválido. Use o formato HH:MM.');
			return;
		}

		// Validar se horário de fim é posterior ao de início
		const startMoment = Moment(newIntervalStartTime, 'HH:mm');
		const endMoment = Moment(newIntervalEndTime, 'HH:mm');
		if (endMoment.isSameOrBefore(startMoment)) {
			toast.warn(
				'Horário de fim deve ser posterior ao horário de início.',
			);
			return;
		}

		setIntervals(prev => [
			...prev,
			{
				date: newIntervalDate,
				start_time: newIntervalStartTime,
				end_time: newIntervalEndTime,
				reason: newIntervalReason || '',
			},
		]);
		setNewIntervalDate('');
		setNewIntervalStartTime('');
		setNewIntervalEndTime('');
		setNewIntervalReason('');
	};

	const handleRemoveInterval = (index: number) => {
		setIntervals(prev => prev.filter((_, i) => i !== index));
	};

	// NOVO: adicionar e remover intervalos simples
	const handleAddSimpleInterval = () => {
		if (!newSimpleIntervalStartTime) {
			toast.warn('Preencha o horário de início.');
			return;
		}
		if (!newSimpleIntervalEndTime) {
			toast.warn('Preencha o horário de fim.');
			return;
		}

		// Validar formato de horário (HH:MM)
		const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
		if (!timeRegex.test(newSimpleIntervalStartTime)) {
			toast.warn('Horário de início inválido. Use o formato HH:MM.');
			return;
		}
		if (!timeRegex.test(newSimpleIntervalEndTime)) {
			toast.warn('Horário de fim inválido. Use o formato HH:MM.');
			return;
		}

		// Validar se horário de fim é posterior ao de início
		const startMoment = Moment(newSimpleIntervalStartTime, 'HH:mm');
		const endMoment = Moment(newSimpleIntervalEndTime, 'HH:mm');
		if (endMoment.isSameOrBefore(startMoment)) {
			toast.warn(
				'Horário de fim deve ser posterior ao horário de início.',
			);
			return;
		}

		setSimpleIntervals(prev => [
			...prev,
			{
				start_time: newSimpleIntervalStartTime,
				end_time: newSimpleIntervalEndTime,
			},
		]);
		setNewSimpleIntervalStartTime('');
		setNewSimpleIntervalEndTime('');
	};

	const handleRemoveSimpleInterval = (index: number) => {
		setSimpleIntervals(prev => prev.filter((_, i) => i !== index));
	};

	return (
		<BitPage>
			<BitHeaderFull
				label={`Cadastro  / Área Comum`}
				icon={''}
				hasIcon={false}
			/>

			<div className="p-5 mb-4 bg-white rounded">
				<h4 className="font-bold mb-4">ADICIONAR ÁREA COMUM</h4>

				<h4 className="font-bold mb-4">
					<span className="bolinha-verde-numero">1</span>
					DADOS ÁREA COMUM
				</h4>

				<div className="bloco-campos-novo-cadastro">
					<div className="grid grid-cols-2 gap-4 mb-10">
						<BitInput
							label="Nome"
							type="text"
							placeholder="Digite..."
							classField="grupo-campo-novos-registros"
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNome({
									value: e.currentTarget.value,
									required: true,
								})
							}
							value={nome.value}
							required={nome.required}
							showRequiredBallon={showRequiredBallon}
						/>
						<BitInput
							label="Tempo de Agendamento (Horas)"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="Digite..."
							classField="grupo-campo-novos-registros"
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setTempoDuracao({
									value: e.currentTarget.value,
									required: true,
								})
							}
							value={tempoDuracao.value}
							required={tempoDuracao.required}
							showRequiredBallon={showRequiredBallon}
						/>
					</div>
					<div className="grid grid-cols-2 gap-4 mb-10">
						<BitInput
							label="Horário Abertura"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setHorarioInicio({
									value: e.currentTarget.value,
									required: horarioInicio.required,
								})
							}
							value={horarioInicio.value}
							required={horarioInicio.required}
							showRequiredBallon={showRequiredBallon}
						/>
						<BitInput
							label="Horário Fechamento"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setHorarioFim({
									value: e.currentTarget.value,
									required: horarioFim.required,
								})
							}
							value={horarioFim.value}
							required={horarioFim.required}
							showRequiredBallon={showRequiredBallon}
						/>
					</div>

					{/* NOVO: Subseção de Intervalos */}
					<div className="mb-10">
						<h5 className="font-semibold mb-4 text-gray-700">
							Intervalos
						</h5>
						<div className="grid grid-cols-3 gap-4 mb-4 items-end">
							<BitInput
								label="Horário de Início"
								type="maskedinput"
								mask={[/\d/, /\d/, ':', /\d/, /\d/]}
								placeholder="00:00"
								classField=""
								onChange={(
									e: React.FormEvent<HTMLInputElement>,
								) =>
									setNewSimpleIntervalStartTime(
										e.currentTarget.value,
									)
								}
								value={newSimpleIntervalStartTime}
								required={false}
								showRequiredBallon={false}
							/>
							<BitInput
								label="Horário de Fim"
								type="maskedinput"
								mask={[/\d/, /\d/, ':', /\d/, /\d/]}
								placeholder="00:00"
								classField=""
								onChange={(
									e: React.FormEvent<HTMLInputElement>,
								) =>
									setNewSimpleIntervalEndTime(
										e.currentTarget.value,
									)
								}
								value={newSimpleIntervalEndTime}
								required={false}
								showRequiredBallon={false}
							/>
							<div className="flex items-end">
								<BitButton
									text={'+'}
									buttonColor={'#3AABA2'}
									textColor={'#FFFFFF'}
									type={'fit px-4 py-2'}
									classesBlockOption={'inline-block'}
									onClick={handleAddSimpleInterval}
								/>
							</div>
						</div>

						{simpleIntervals.length > 0 && (
							<div className="overflow-x-auto mb-6">
								<table className="min-w-full text-left">
									<thead>
										<tr>
											<th className="px-2 py-2">
												Horário Início
											</th>
											<th className="px-2 py-2">
												Horário Fim
											</th>
											<th className="px-2 py-2">Ações</th>
										</tr>
									</thead>
									<tbody>
										{simpleIntervals.map((i, idx) => (
											<tr key={idx} className="border-t">
												<td className="px-2 py-2">
													{i.start_time}
												</td>
												<td className="px-2 py-2">
													{i.end_time}
												</td>
												<td className="px-2 py-2">
													<BitButton
														text={'REMOVER'}
														buttonColor={'#DC2626'}
														textColor={'#FFFFFF'}
														type={'fit px-4'}
														classesBlockOption={
															'inline-block'
														}
														onClick={() =>
															handleRemoveSimpleInterval(
																idx,
															)
														}
													/>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						)}
					</div>

					<div className="grid grid-cols-2 gap-4 mb-10">
						<BitInput
							label="Data de Início"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setDataInicio({
									value: e.currentTarget.value,
									required: dataInicio.required,
								})
							}
							value={dataInicio.value}
							required={dataInicio.required}
							showRequiredBallon={showRequiredBallon}
						/>
						<BitInput
							label="Data de Fim"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setDataFim({
									value: e.currentTarget.value,
									required: dataFim.required,
								})
							}
							value={dataFim.value}
							required={dataFim.required}
							showRequiredBallon={showRequiredBallon}
						/>
					</div>
					<div className="mb-10">
						<BitInput
							label="Observações (opcional)"
							type="textarea"
							placeholder="Digite observações sobre a área comum..."
							classField=""
							onChange={(
								e: React.FormEvent<HTMLTextAreaElement>,
							) =>
								setObservacoes({
									value: e.currentTarget.value,
									required: observacoes.required,
								})
							}
							value={observacoes.value}
							required={observacoes.required}
							showRequiredBallon={showRequiredBallon}
						/>
					</div>
				</div>

				<h4 className="font-bold mb-4">
					<span className="bolinha-verde-numero">2</span>
					EMPREENDIMENTO
				</h4>

				<div className="bloco-campos-novo-cadastro">
					<div className="mb-4">
						<BitInput
							label="Nome do empreendimento"
							type="select"
							multipleSelect={false}
							placeholder=""
							valuesSelect={empreendimentos.value}
							classField="grupo-campo-novos-registros"
							onChange={(
								e: React.FormEvent<HTMLSelectElement>,
							) => {
								const allOptions = Object.entries(
									e.currentTarget.options,
								);
								const newValueEmpreendimentos: {
									value: string | number;
									label: string;
									selected: boolean;
								}[] = [];

								allOptions.map(option => {
									if (option[1].value !== '') {
										newValueEmpreendimentos.push({
											value: option[1].value,
											label: option[1].text,
											selected: option[1].selected,
										});
									}
									return null;
								});

								setEmpreendimentos({
									value: newValueEmpreendimentos,
									required: empreendimentos.required,
								});
							}}
						/>
					</div>
				</div>
				<h4 className="font-bold mb-4">
					<span className="bolinha-verde-numero">3</span>
					Política de Agendamento
				</h4>

				<div className="bloco-campos-novo-cadastro">
					<div className="mb-4">
						<BitInput
							label="Política"
							type="select"
							multipleSelect={false}
							placeholder=""
							valuesSelect={politicaDeAgendamento.value}
							classField="grupo-campo-novos-registros"
							onChange={(
								e: React.FormEvent<HTMLSelectElement>,
							) => {
								const allOptions = Object.entries(
									e.currentTarget.options,
								);
								const newValuePoliticaAgendamento: {
									value: string | number;
									label: string;
									selected: boolean;
								}[] = [];

								allOptions.map(option => {
									if (option[1].value !== '') {
										newValuePoliticaAgendamento.push({
											value: option[1].value,
											label: option[1].text,
											selected: option[1].selected,
										});
									}
									return null;
								});

								setPoliticaDeAgendamento({
									value: newValuePoliticaAgendamento,
									required: empreendimentos.required,
								});
							}}
						/>
						{!isBlockedInterval && (
							<div className="mb-4">
								<BitInput
									label="Intervalo"
									type="number"
									placeholder="Digite..."
									classField=""
									onChange={(
										e: React.FormEvent<HTMLInputElement>,
									) =>
										setInterval({
											value: e.currentTarget.value,
											required: intervalo.required,
										})
									}
									value={intervalo.value}
									required={
										intervalo.required || !isBlockedInterval
									}
									showRequiredBallon={showRequiredBallon}
									disabled={isBlockedInterval}
								/>
							</div>
						)}
					</div>
				</div>

				{/* NOVO: Seção de Bloqueios de Período */}
				<h4 className="font-bold mb-4">
					<span className="bolinha-verde-numero">4</span>
					Bloqueios de Período
				</h4>
				<div className="bloco-campos-novo-cadastro">
					<div className="grid grid-cols-3 gap-4 mb-4">
						<BitInput
							label="Data de Início do Bloqueio"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewBlockStartDate(e.currentTarget.value)
							}
							value={newBlockStartDate}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Data de Fim do Bloqueio (opcional)"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewBlockEndDate(e.currentTarget.value)
							}
							value={newBlockEndDate}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Motivo (opcional)"
							type="text"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewBlockReason(e.currentTarget.value)
							}
							value={newBlockReason}
							required={false}
							showRequiredBallon={false}
						/>
					</div>
					<div className="mb-6">
						<BitButton
							text={'ADICIONAR BLOQUEIO'}
							buttonColor={'#3AABA2'}
							textColor={'#FFFFFF'}
							type={'fit px-6'}
							classesBlockOption={'inline-block'}
							onClick={handleAddBlock}
						/>
					</div>

					{blocks.length > 0 && (
						<div className="overflow-x-auto mb-6">
							<table className="min-w-full text-left">
								<thead>
									<tr>
										<th className="px-2 py-2">
											Data Início
										</th>
										<th className="px-2 py-2">Data Fim</th>
										<th className="px-2 py-2">Motivo</th>
										<th className="px-2 py-2">Ações</th>
									</tr>
								</thead>
								<tbody>
									{blocks.map((b, idx) => (
										<tr key={idx} className="border-t">
											<td className="px-2 py-2">
												{Moment(b.start_date).format(
													'DD/MM/YYYY',
												)}
											</td>
											<td className="px-2 py-2">
												{b.end_date
													? Moment(b.end_date).format(
															'DD/MM/YYYY',
													  )
													: '-'}
											</td>
											<td className="px-2 py-2">
												{b.reason}
											</td>
											<td className="px-2 py-2">
												<BitButton
													text={'REMOVER'}
													buttonColor={'#DC2626'}
													textColor={'#FFFFFF'}
													type={'fit px-4'}
													classesBlockOption={
														'inline-block'
													}
													onClick={() =>
														handleRemoveBlock(idx)
													}
												/>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}
				</div>

				{/* NOVO: Seção de Bloqueios de Horários */}
				<h4 className="font-bold mb-4">
					<span className="bolinha-verde-numero">5</span>
					Bloqueios de Horários
				</h4>
				<div className="bloco-campos-novo-cadastro">
					<div className="grid grid-cols-4 gap-4 mb-4">
						<BitInput
							label="Data do Bloqueio"
							type="date"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewIntervalDate(e.currentTarget.value)
							}
							value={newIntervalDate}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Horário de Início"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="00:00"
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewIntervalStartTime(e.currentTarget.value)
							}
							value={newIntervalStartTime}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Horário de Fim"
							type="maskedinput"
							mask={[/\d/, /\d/, ':', /\d/, /\d/]}
							placeholder="00:00"
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewIntervalEndTime(e.currentTarget.value)
							}
							value={newIntervalEndTime}
							required={false}
							showRequiredBallon={false}
						/>
						<BitInput
							label="Motivo (opcional)"
							type="text"
							placeholder="Digite..."
							classField=""
							onChange={(e: React.FormEvent<HTMLInputElement>) =>
								setNewIntervalReason(e.currentTarget.value)
							}
							value={newIntervalReason}
							required={false}
							showRequiredBallon={false}
						/>
					</div>
					<div className="mb-6">
						<BitButton
							text={'ADICIONAR BLOQUEIO DE HORÁRIO'}
							buttonColor={'#3AABA2'}
							textColor={'#FFFFFF'}
							type={'fit px-6'}
							classesBlockOption={'inline-block'}
							onClick={handleAddInterval}
						/>
					</div>

					{intervals.length > 0 && (
						<div className="overflow-x-auto mb-6">
							<table className="min-w-full text-left">
								<thead>
									<tr>
										<th className="px-2 py-2">Data</th>
										<th className="px-2 py-2">
											Horário Início
										</th>
										<th className="px-2 py-2">
											Horário Fim
										</th>
										<th className="px-2 py-2">Motivo</th>
										<th className="px-2 py-2">Ações</th>
									</tr>
								</thead>
								<tbody>
									{intervals.map((i, idx) => (
										<tr key={idx} className="border-t">
											<td className="px-2 py-2">
												{Moment(i.date).format(
													'DD/MM/YYYY',
												)}
											</td>
											<td className="px-2 py-2">
												{i.start_time}
											</td>
											<td className="px-2 py-2">
												{i.end_time}
											</td>
											<td className="px-2 py-2">
												{i.reason}
											</td>
											<td className="px-2 py-2">
												<BitButton
													text={'REMOVER'}
													buttonColor={'#DC2626'}
													textColor={'#FFFFFF'}
													type={'fit px-4'}
													classesBlockOption={
														'inline-block'
													}
													onClick={() =>
														handleRemoveInterval(
															idx,
														)
													}
												/>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}
				</div>

				<div className="text-right">
					<div className="inline-block mr-4">
						<BitLinkButton
							text={'VOLTAR'}
							buttonColor={'#3AABA2'}
							textColor={'#FFFFFF'}
							link={'/common-areas'}
						/>
					</div>
					<BitButton
						text={'FINALIZAR'}
						buttonColor={'#3AABA2'}
						textColor={'#FFFFFF'}
						type={'fit px-10'}
						classesBlockOption={'inline-block'}
						onClick={handleCadastrar}
					/>
				</div>
				<ToastContainer
					position="bottom-right"
					autoClose={2000}
					hideProgressBar
					newestOnTop={false}
					closeOnClick={false}
					rtl={false}
					pauseOnFocusLoss
					draggable={false}
					pauseOnHover
				/>
			</div>
		</BitPage>
	);
};

export default NewAreaComum;
